import React from 'react';
import PropTypes from 'prop-types';
import MetaIdTypeaheadField from './MetaIdTypeaheadField';
import {
  searchMetaTargeting,
  getMetaTargetingByIds,
} from '../../../shared/budgetApi';

/**
 * MetaTargetingField
 *
 * Targeting ID row (income, family_statuses, ...): typeahead over Meta's
 * targeting search, limited to `targetingType`, with the option name shown to
 * the right of the ID.
 * @param {string} targetingType - Meta targeting type (e.g. 'income', 'family_statuses')
 */
const MetaTargetingField = ({ targetingType, ...props }) => (
  <MetaIdTypeaheadField
    {...props}
    searchFn={searchMetaTargeting}
    lookupFn={getMetaTargetingByIds}
    extraParams={{ type: targetingType }}
    noResultsMessage="No targeting options found"
    unknownLabel="Unknown option"
  />
);

MetaTargetingField.propTypes = {
  targetingType: PropTypes.string.isRequired,
};

export default MetaTargetingField;
